module.exports = __webpack_public_path__ + "static/IvarText-Regular-87451ef2e5751455e1fa455177123207.woff2";